<template>
<div>
 <p style="float:right;"><em>2021 &ndash; ??</em></p>
  <p class="text-h5">Redistricting Resources</p>

<p>Extensive resources are available online to learn more about the redistricting process, participate in redistricting campaigns in your state, analyze district proposals, engage in map drawing, and make your voice heard. Some of these are listed below. Please <a href="mailto:cunymapping@gc.cuny.edu">contact us</a> if you have others we can add.</p>

<p class="text-h6 mb-1 mt-2">2020 Census data for redistricting</p>
<ul>
    <li>
    <a href="https://www.census.gov/programs-surveys/decennial-census/about/rdo/summary-files.html" target="_blank">Census Bureau descriptions &amp; supporting documents</a>
    </li>
    <li>
    <a href="https://www.census.gov/programs-surveys/decennial-census/decade/2020/planning-management/release/redistricting-data-product-faqs.html" target="_blank">Redistricting Data FAQs</a>
    </li>
    <li>
    <a href="https://www2.census.gov/programs-surveys/decennial/2020/data/01-Redistricting_File--PL_94-171/" target="_blank">2020 data in "legacy" format</a>
    </li>
    <li>
    <a href="https://www2.census.gov/geo/tiger/TIGER2020/" target="_blank">2020 "TIGER" files (geographic data)</a>
    </li>
  </ul>

  <p class="text-h6 mb-1 mt-2">Election data/precinct resources</p>
<ul>
  <li>
    <a href="https://www.electiondataservices.com/" target="_blank">Election Data Services</a>
  </li>
  <li>
    <a href="http://openelections.net/" target="_blank">OpenElections</a>
  </li>
   <li>
    <a href="https://projects.iq.harvard.edu/eda/home" target="_blank">Harvard Election Data Archive</a>
  </li>
    <li>
    <a href="https://github.com/nvkelso/election-geodata" target="_blank">Election Geodata</a>
  </li>
    <li>
    <a href="https://www.redistrictingdatahub.org/" target="_blank">Redistricting Data Hub</a>
  </li>
    <li>
    <a href="https://openprecincts.org/" target="_blank">OpenPrecincts</a>
  </li>
</ul>

  <p class="text-h6 mb-1 mt-2">Redistricting process</p>
<ul>
    <li>
    <a href="https://projects.fivethirtyeight.com/redistricting-2022-maps/" target="_blank">Analysis of district plans at FiveThirtyEight</a>
  </li>
  <li>
    <a href="https://redistricting.lls.edu/" target="_blank">All About Redistricting</a>
  </li>
  <li>
    <a href="https://gerrymander.princeton.edu/" target="_blank">Princeton Gerrymandering Project</a>
  </li>
  <li>
    <a href="https://www.ncsl.org/research/redistricting.aspx" target="_blank">Redistricting resources from NCSL</a> 
  </li> 
   <li>
    <a href="https://redistrictingonline.org/" target="_blank">Redistricting Online</a> 
  </li>
    <li>
    <a href="https://ballotpedia.org/State_redistricting_deadlines_after_the_2020_census" target="_blank">Redistricting timeline from Ballotpedia</a> 
  </li>
</ul>

  <p class="text-h6 mb-1 mt-2">Mapmaking resources</p>
  <p>The resources below are free/open source except where noted.</p>
<ul>
  <li>
    <a href="https://www.districtbuilder.org/" target="_blank">DistrictBuilder</a>
  </li>
   <li>
    <a href="https://davesredistricting.org/maps#home" target="_blank">Dave's Redistricting App</a> 
  </li>
   <li>
    <a href="https://representable.org/" target="_blank">Representable</a>
  </li>  
    <li>
    <a href="https://districtr.org/" target="_blank">Districtr</a>
  </li>
    <li>
    <a href="https://antimander.org/" target="_blank">Antimander</a>
  </li>
    <li>
    <a href="https://planscore.org/" target="_blank">PlanScore</a> 
  </li>
    <li>
    <a href="https://what-the-district.aclu.org/" target="_blank">What the District?!</a>
  </li>
    <li>
    <a href="https://www.caliper.com/maptitude/solutions/political/2020-redistricting-software.htm" target="_blank">Maptitude</a> (fee-based) 
  </li>
</ul>

</div>
</template>
<script>

export default {
  name: "ModalResources",
  components: {
    // ModalTabOpeners
  },
  data: function () {
    return {};
  },
  methods:{}
};
</script>
<style scoped>
</style>